<template>
  <div class="background-image">
    <div class="container-full-page">
      <v-card style="border-radius: 20px;" class="px-4 pt-8 mx-4" elevation="8">
        <div class="container-form-login" style="display: flex; flex-direction: column;">
          <div class="form-container">
            <div class="content-image cursor-pointer">
              <img
                style="max-width: 400px; width: 100%; object-fit: contain; margin: auto;"
                src="../../assets/logos/Logotipo_Dos tintas.png"
                alt="Fresher-logo.png"
              >
            </div>
            <p class="text-title mon-bold mt-5" style="color: #193D6E;">{{ "Crear cuenta" }}</p>
            <p class="text-subtitle">{{ "Completa los siguientes campos para registrarte" }}</p>
            <v-form ref="registerForm" v-model="registerFormValid" class="mt-2 mx-4" style="width: 100%;">
              <v-col>
                <div style="display: flex; gap: 16px;">
                  <v-text-field
                    v-model="sName"
                    name="name"
                    outlined
                    color="#000000"
                    class="global-inputs mon-regular"
                    label="Nombre"
                    placeholder="Nombre"
                    :rules="nameRules"
                    persistent-placeholder
                  />
                  <v-text-field
                    v-model="sLastname"
                    name="lastName"
                    outlined
                    color="#000000"
                    class="global-inputs mon-regular"
                    label="Apellido"
                    placeholder="Apellido"
                    :rules="nameRules"
                    persistent-placeholder
                  />
                </div>

                <div style="display: flex; gap: 16px;">
                  <v-text-field
                    v-model="email"
                    type="email"
                    name="email"
                    outlined
                    color="#000000"
                    class="global-inputs mon-regular mt-5"
                    label="Correo electrónico"
                    placeholder="Ingresa tu correo"
                    :rules="emailRules"
                    persistent-placeholder
                  />

                  <v-text-field
                    v-model="phone"
                    type="number"
                    name="phone"
                    outlined
                    color="#000000"
                    class="global-inputs mon-regular mt-5"
                    label="Numero telefonico"
                    placeholder="Ingresa tu numero"
                    :rules="nameRules"
                    persistent-placeholder
                  />
                </div>
                  <v-text-field
                    v-model="empresa"
                    type="string"
                    name="empresa"
                    outlined
                    color="#000000"
                    class="global-inputs mon-regular mt-5"
                    label="Empresa"
                    placeholder="Empresa"
                    :rules="nameRules"
                    persistent-placeholder
                  />
                <v-text-field
                  v-model="password"
                  name="password"
                  :append-icon="bShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  label="Contraseña"
                  placeholder="Crea una contraseña"
                  @click:append="() => (bShowPassword = !bShowPassword)"
                  :type="bShowPassword ? 'text' : 'password'"
                  outlined
                  color="#000000"
                  class="global-inputs mon-regular mt-5"
                  :rules="passwordRules"
                  hint="Debe tener mínimo 6 caracteres y un carácter especial (por ejemplo: !@#$%)"
                  persistent-hint
                  persistent-placeholder
                />

                <v-text-field
                  v-model="confirmPassword"
                  name="confirmPassword"
                  :append-icon="bShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  label="Confirmar contraseña"
                  placeholder="Repite la contraseña"
                  @click:append="() => (bShowPassword = !bShowPassword)"
                  :type="bShowPassword ? 'text' : 'password'"
                  outlined
                  color="#000000"
                  class="global-inputs mon-regular mt-5"
                  :rules="confirmPasswordRules"
                  persistent-placeholder
                />

                <div class="center-horizontall mt-5">
                  <v-btn
                    @click="register"
                    elevation="0"
                    color="#0275b8"
                    :loading="bLoading"
                    class="button-login mon-bold px-12"
                    :disabled="!registerFormValid"
                  >
                    {{ 'Crear Cuenta' }}
                  </v-btn>
                </div>
              </v-col>
            </v-form>
          </div>
        </div>
      </v-card>
    </div>
    <div class="footer-login">
      <p class="footer-text-left mon-regular">
        ©{{ new Date().getFullYear() }} FRESHER. Todos los derechos reservados.
      </p>
      <p class="footer-text-right mon-regular">
        <a href="/terms" class="footer-link">Términos y condiciones</a> |
        <a href="/privacy" class="footer-link">Aviso de privacidad</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisterView",
  data() {
    return {
      sName: "",
      sLastname: "",
      phone: "",
      empresa: "",
      email: "",
      password: "",
      confirmPassword: "",
      bShowPassword: false,
      bLoading: false,
      registerFormValid: false,
    };
  },
  methods: {
    register() {
      if (this.password !== this.confirmPassword) return;
        this.bLoading = true;
        const payload = {
          sName: this.sName,
          sLastname: this.sLastname,
          phone: this.phone,
          empresa: this.empresa,
          sEmail: this.email,
          sPassword: this.password,
        };

        DB.post(`${URI}/api/v1/${this.selectLanguage}/users/createUserWithoutEnterprise`, payload)
          .then(() => {
            this.bLoading = false;
            this.$router.push("/login");
          })
          .catch((error) => {
            this.bLoading = false;
            this.mixError(error.response.data.message, error.response.status);
          });
    },
  },
  computed: {
    selectLanguage() {
      return this.$store.state.language;
    },
    nameRules() {
      return [(v) => !!v || "Nombre requerido"];
    },
    emailRules() {
      return [
        (v) => !!v || "Correo requerido",
        (v) => /.+@.+\..+/.test(v) || "Correo inválido",
      ];
    },
    passwordRules() {
      return [
        (v) => !!v || "Contraseña requerida",
        (v) => v.length >= 6 || "Mínimo 6 caracteres",
        (v) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(v) || "Debe contener al menos un carácter especial",
      ];
    },
    confirmPasswordRules() {
      return [
        (v) => !!v || "Confirmar contraseña es requerido",
        (v) => v === this.password || "Las contraseñas no coinciden",
      ];
    },
  },
};
</script>

<style scoped>
  .language-buttons {
    display: flex;
    gap: 10px;
  }
  .language-buttons button {
    border: none;
    background: none;
    cursor: pointer;
  }
  .language-buttons .selected {
    background-color: #B8C7D4;
  }
  .Header {
    justify-content: space-between;
    display: flex;
    align-items: center; 
    flex-direction: row;
    padding: 20px;
  }
  .header-content {
    display: flex;
    align-items: center;;
    width: 100%;
  }
  .language-selector {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .menu-language {
    background-color: #EDF3FF;
  }
  .flag-image {
    width: 50px;
    align-items: center;
    justify-content: center;
    padding-left: 7px;
    padding-right: 7px;
    padding-top: 7px;
    padding-bottom: 0px;
  }
  .account-section {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    margin-left: auto;
  }
  .Btn-Account {
    border: 2px solid #0075B8;
    color: #0075B8;
    background-color: #fff;
    padding: 10px 20px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .Btn-Account:hover {
    background-color: #0075B8;
    color: #fff;
  }
  .Btn-text {
    display: flex;
    justify-content: center;
    align-items: center; 
    width: 10vw;
    margin-right: 15px;
    margin-top: 15px;
  }
  .form-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  .container-full-page {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100vh;
    align-items: center;
  }
  .container-form-login {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
  }
  .footer-login {
    width: 100%;
    padding: 10px 20px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    background: transparent;
    bottom: 0px;
  }
  .footer-text-left,
  .footer-text-right {
    font-size: 12px;
    color: #FFFFFF;;
  }
  .footer-link {
    color: #FFFFFF;
    text-decoration: none;
  }
  .footer-link:hover {
    text-decoration: underline;
  }
  .button-create-account {
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #283c4d;
    border-radius: 12px;
    opacity: 1;
    background-color: #ffffff !important;
    text-transform: initial;
    font-size: 14px;
    width: 100%;
  }
  .link-forgot-password {
    text-transform: initial;
    color: #0049b7;
    text-decoration: underline;
    letter-spacing: 0px;
  }
  .button-login {
    width: 100%;
    height: 40px !important;
    border-radius: 10px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 14px;
    text-transform: initial;
  }
  .text-title {
    font-size: 30px;
    text-align: center;
    letter-spacing: 0px;
  }
  .text-subtitle {
    font-size: 15px;
    text-align: center;
    letter-spacing: 0px;
    font-weight: 100;
  }
  .center-horizontall {
    display: flex;
    justify-content: center;
  }

  .content-image {
    width: 260px;
    height: 45px;
  }

  .content-image img {
    width: 100%;
    height: auto;
  }

  @supports (object-fit: cover) {
    .content-image img {
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }

  .content-login {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: -13%;
  }

  @media (max-width: 720px) {
    .form-container {
      width: 80vw;
      height: auto;
    }

    .text-title {
      font-size: 25px;
    }
  }
  .background-image {
    background-image: url('../../assets/images/login-cover.png');
    background-size: cover;
    background-position: center;
  }
</style>